import { render, staticRenderFns } from "./MilestoneAwardSetupTab.vue?vue&type=template&id=518f5b7c&scoped=true&"
import script from "./MilestoneAwardSetupTab.vue?vue&type=script&setup=true&lang=js&"
export * from "./MilestoneAwardSetupTab.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./MilestoneAwardSetupTab.vue?vue&type=style&index=0&id=518f5b7c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "518f5b7c",
  null
  
)

export default component.exports